import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {ButtonDirective} from "primeng/button";
import {DialogModule} from "primeng/dialog";
import {EditorTextComponent} from "../../../../shared/components/editor-text/editor-text.component";
import {PrimeTemplate} from "primeng/api";
import {Ripple} from "primeng/ripple";
import {ListboxModule} from "primeng/listbox";
import {FormsModule} from "@angular/forms";
import {CheckboxModule} from "primeng/checkbox";
import {NgIf} from "@angular/common";
import {
    AvisosObservaciones,
    EvaluacionesInterface,
    EvaluacionEstadosControl,
    SolicitudEvalDocInterface, SolicitudEvalDocTipoInterface
} from "../../interfaces/evaluaciones.interface";
import Swal from "sweetalert2";
import {ProyectoItem} from "../../../../users/interfaces/proyecto.interface";
import {EvaluacionesService} from "../../services/evaluaciones.service";
import {LoginServices} from "../../../../auth/login/services/login.service";
import {SharedModule} from "../../../../shared/shared.module";
import {TooltipModule} from "primeng/tooltip";
import {ProyectoService} from "../../../../users/proyectos/services/proyecto.service";

@Component({
  selector: 'app-notificar-solicitud-obs',
  standalone: true,
    imports: [
        ButtonDirective,
        DialogModule,
        EditorTextComponent,
        PrimeTemplate,
        Ripple,
        ListboxModule,
        FormsModule,
        CheckboxModule,
        NgIf,
        SharedModule,
        TooltipModule
    ],
  templateUrl: './notificar-solicitud-obs.component.html',
  styleUrl: './notificar-solicitud-obs.component.scss'
})
export class NotificarSolicitudObsComponent implements OnInit{
    @Input() openDialog: boolean=false
    @Input() titleHeader: string='';
    @Input() type: number=0;
    @Input() textReadOnly: boolean=false
    @Input() idSolicitudEval: string='';
    @Input() evaluaciones: EvaluacionesInterface[]=[];
    @Input() selected: ProyectoItem | null = null;
    @Input() infoDictamen!: SolicitudEvalDocTipoInterface;
    @Input() infoObservacion!: AvisosObservaciones;
    @Output() onEventEmitterClose = new EventEmitter<boolean>;
    descripcion:string='';
    selectAll = false;
    _showLoader: boolean = false
    selectedItems: EvaluacionesInterface[] = [];
    evalDoc:SolicitudEvalDocInterface={creadoPor: '', idSolicitud: 0, idUsuario: '', opinionTecnica: '', idEvaluacion: 0,tipo:0}
    protected readonly EvaluacionEstadosControl = EvaluacionEstadosControl;
    constructor(private evaluacioneService:EvaluacionesService, private loginServices:LoginServices, private proyectoService:ProyectoService) {
    }

    ngOnInit(): void {
        this.selectedItems = this.evaluaciones.filter(e => e.completado); //muestra los items filtrados completado y aparecen checks
        this.descripcion = this.getSelectedItemNames();
    }
    private fetchTimeLineEvents() {
        if (this.selected?.idSolicitud != null) {
            this.evaluacioneService.getTimeLine(this.selected?.idSolicitud!,Number.parseInt(this.idSolicitudEval),this.loginServices.session()?.perfil.uniqueId!)
                .subscribe({
                    next: (result) => {
                        if (result && result.body) {
                            this.evaluacioneService._timelineEvents.set(result.body);
                        }
                    },
                    error: (error) => {
                        console.log(error)
                    },
                    complete: () => {
                    }
                });
        }
    }
    private getObtenerAvisoObservaciones(idSolicitud:number, idSolicitudEval:number | null, usuario:string, type:string) {
        if (this.selected?.idSolicitud != null) {
            this.evaluacioneService.obtenerAvisoObservacionesParam(idSolicitud!,idSolicitudEval!,usuario, type)
                .subscribe({
                    next: (result) => {
                        if (result && result.body) {
                            this.evaluacioneService._notificaciones.set(result.body!);
                        }
                    },
                    error: (error) => {
                        console.log(error)
                    },
                    complete: () => {
                    }
                });
        }
    }
    guardar() {
        if (!this.loginServices.hasRoles(['tecnico_resolutor'])){
            return;
        }
        this.evalDoc={creadoPor: this.loginServices.session()?.perfil.usuario!,
            idSolicitud: this.selected?.idSolicitud!,
            idUsuario: this.loginServices.session()?.perfil.uniqueId!,
            opinionTecnica: this.descripcion, idEvaluacion: Number.parseInt(this.idSolicitudEval), tipo:this.type}
        if(this.type==EvaluacionEstadosControl.Dictamen){
            this.guardarDictamen();
        }else{
            this.guardarObservacion();
        }
    }
    private guardarDictamen() {
        Swal.fire({
            icon: "question",
            title: `¿Está seguro que desea guardar el dictamen que acaba de redactar de la solicitud #${ this.selected?.numeroExpediente }?`,
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Si, confirmar",
            denyButtonText: `No, cancelar`,
            confirmButtonColor: "#28a745"
        }).then((result) => {
            if (result.isConfirmed) {
               this.procesarDictamenes();
                this._showLoader=true;
            }
        });
    }
    private guardarObservacion() {
        Swal.fire({
            icon: "question",
            title: "¿Está seguro que desea notificar al cliente las observaciones redactadas?",
            html: `
                <ul style="text-align: left; font-size: 1rem; padding-left: 1.2em;">
                  <li>Esta operación cambiará el estado de la solicitud a <b>observada</b>.</li>
                  <li>Esta operación habilitará los requisitos que tienen observación para subsanación.</li>
                </ul>
              `,
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Sí, confirmar",
            denyButtonText: "No, cancelar",
            confirmButtonColor: "#28a745"
        }).then((result) => {
            if (result.isConfirmed) {
                this.procesarObservaciones();
                this._showLoader=true;
            }
        });
    }

    private procesarObservaciones() {
        this.evaluacioneService.procesarEvalObservaciones(this.evalDoc).subscribe({
            next: (result) => {
                if (result.status == 200) {
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "Éxito se ha procesado observaciones correctamente.",
                        showConfirmButton: false,
                        timer: 2000
                    });
                    this._showLoader=false;
                }
            },
            error: (error) => {
                console.log(error)
                if (error.status == 409) {
                    console.log("Error: Ya se cuenta con un registro de observaciones notificadas para la evaluación.")
                }else{
                    Swal.fire({
                        icon: "error",
                        title: `Error: No se pudo procesar observaciones.`,
                        showDenyButton: true,
                        showConfirmButton: false,
                        denyButtonText: `Ok`
                    });
                }
                this._showLoader=false;
            },
            complete: () => {
                this.closeDialog();
                this._showLoader=false;
                setTimeout(() => {
                    this.getObtenerAvisoObservaciones(this.evalDoc.idSolicitud!,this.evalDoc.idEvaluacion,this.loginServices.session()?.perfil.usuario!,"1");
                    this.fetchTimeLineEvents();
                }, 3000);
            }
        });
    }
    private procesarDictamenes() {
        this.evaluacioneService.procesarEvalDictamen(this.evalDoc).subscribe({
            next: (result) => {
                if (result.status == 200) {
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "Éxito se ha procesado dictamen correctamente.",
                        showConfirmButton: false,
                        timer: 2000
                    });
                    this._showLoader=false;
                }
            },
            error: (error) => {
                console.log(error)
                if (error.status == 409) {
                    Swal.fire({
                        icon: "error",
                        title: `Error: Ya se cuenta con un registro de su dictamen para la evaluación.`,
                        showDenyButton: true,
                        showConfirmButton: false,
                        denyButtonText: `Ok`
                    });
                }else{
                    Swal.fire({
                        icon: "error",
                        title: `Error: No se pudo procesar dictamen.`,
                        showDenyButton: true,
                        showConfirmButton: false,
                        denyButtonText: `Ok`
                    });
                }
                this._showLoader=false;
            },
            complete: () => {
                this.closeDialog();
                this._showLoader=false;
                this.fetchTimeLineEvents();
            }
        });
    }

    onSelectAllChange(event:any) {
        this.selectedItems = event.checked ? [...this.evaluaciones] : [];
        this.selectAll = event.checked;
        event.updateModel(this.selectedItems, event.originalEvent)
    }

    onChange(event:any) {
        const { originalEvent, value } = event
        if(value) this.selectAll = value.length === this.evaluaciones.length;
    }
    isSelected(item: any): boolean {
        return this.selectedItems.includes(item);
    }

    toggleSelection(item: any): void {
        if (this.isSelected(item)) {
            this.selectedItems = this.selectedItems.filter(i => i !== item);
        } else {
            this.selectedItems.push(item);
        }
    }

    closeDialog(){
        this.openDialog = false;
        this.onEventEmitterClose.emit(false);
    }
    onEditorText(event: string) {
        this.descripcion=event
    }

    getSelectedItemNames(): string {
        return this.selectedItems
            .map(item => `${item.evalNombre}${item.observacion!==null?', '+item.observacion:''}`)
            .join('<br />');
    }

    getSelectedDictamenInfo(): string {
        return this.infoDictamen?.opinionTecnica
    }
    getObservacioneInfo(): string {
        return this.infoObservacion?.opinionTecnica == undefined ? '':this.infoObservacion?.opinionTecnica!;
    }
    tagStyle(estado: boolean) {
        switch (estado) {
            case true:
                return {background: '#28a745'};
            case false:
                return {background: '#FF0000FF'};
            default:
                return {background: '#6c757d'};
        }
    }
}
